import { render, staticRenderFns } from "./DraggablePanel.vue?vue&type=template&id=1500ddc7&scoped=true"
import script from "./DraggablePanel.vue?vue&type=script&lang=js"
export * from "./DraggablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1500ddc7",
  null
  
)

export default component.exports